import { LegalLayout, LegalSection } from "@/components/site/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="August 17, 2026" testid="terms-page">
      <p className="text-white/70">
        These Terms of Service (&quot;Terms&quot;) govern your use of the Mobyle website and
        any services you engage us to provide. By accessing our website or working
        with us, you agree to these Terms. If you do not agree, please do not use
        the site.
      </p>

      <LegalSection heading="1. Our services">
        <p>
          Mobyle designs and builds custom websites, applications and AI
          automations. The specific scope, deliverables, timeline and price for any
          project will be set out in a separate written proposal or agreement. Those
          project terms take precedence over these general Terms where they conflict.
        </p>
      </LegalSection>

      <LegalSection heading="2. Use of the website">
        <p>You agree not to:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Use the site in any unlawful way or for any unlawful purpose.</li>
          <li>Attempt to gain unauthorised access to our systems or interfere with the site&apos;s operation.</li>
          <li>Copy, reproduce or redistribute our content without permission.</li>
          <li>Submit false, misleading or infringing information through our forms.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="3. Intellectual property">
        <p>
          All content on this website — including text, graphics, logos and design —
          is owned by or licensed to Mobyle and is protected by applicable laws.
          Ownership of deliverables produced during a client engagement is governed
          by the relevant project agreement; unless stated otherwise, ownership
          transfers upon full payment.
        </p>
      </LegalSection>

      <LegalSection heading="4. Consultations & quotes">
        <p>
          Any consult, blueprint, estimate or quote we provide is for planning
          purposes and does not constitute a binding commitment until confirmed in a
          signed proposal or agreement. Pricing and timelines may change based on
          final scope.
        </p>
      </LegalSection>

      <LegalSection heading="5. Payment">
        <p>
          Fees, payment schedules and invoicing terms for any engagement are defined
          in the applicable project agreement. Late or non-payment may result in
          paused work or suspension of services.
        </p>
      </LegalSection>

      <LegalSection heading="6. Third-party services">
        <p>
          Our website and the solutions we build may rely on third-party services
          and platforms. We are not responsible for the availability, performance or
          terms of those third parties, and your use of them may be subject to their
          own agreements.
        </p>
      </LegalSection>

      <LegalSection heading="7. Disclaimers">
        <p>
          The website is provided on an &quot;as is&quot; and &quot;as available&quot; basis without
          warranties of any kind, whether express or implied, to the fullest extent
          permitted by law. We do not warrant that the site will be uninterrupted,
          error-free or secure.
        </p>
      </LegalSection>

      <LegalSection heading="8. Limitation of liability">
        <p>
          To the maximum extent permitted by law, Mobyle will not be liable for any
          indirect, incidental, special or consequential damages arising from your
          use of the website. Our total liability relating to the website is limited
          to the amount you paid us, if any, for access to it.
        </p>
      </LegalSection>

      <LegalSection heading="9. Changes to these terms">
        <p>
          We may update these Terms from time to time. Continued use of the website
          after changes are posted constitutes acceptance of the updated Terms.
        </p>
      </LegalSection>

      <LegalSection heading="10. Contact us">
        <p>
          Questions about these Terms? Reach us at{" "}
          <a href="mailto:hello@gomobyle.com" className="text-teal hover:underline">
            hello@gomobyle.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
